export default __webpack_public_path__ + "static/media/ammeter.badd0724.svg";